import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import { Email } from 'helper/mailer';
import Accordion from 'components/Accordion';
import { cssVar } from 'constants/theme';
import EmailRead from './EmailRead';

import './index.scss';

export default function ReportUserCard({ email }: {
  email: Email,
}) {
  const { reads } = email;

  return (
    <div className="report-user-card">
      <h3>{email.mailTo}</h3>
      <Icon iconType="file" size="small" color={cssVar('text-accent')} />
      <span className="ms-1">{email.identifier}</span>
      {reads.length > 0 && (
        <h4 className="mt-3 mb-1">Views:</h4>
      )}
      {reads.length === 1 && (
        <EmailRead readInfo={reads[0]} />
      )}
      {reads.length > 1 && (
        <Accordion>
          <Accordion.Header>
            <EmailRead readInfo={reads[0]} />
          </Accordion.Header>
          <Accordion.Body>
            {reads.slice(1).map((read) => (
              <div className="mt-3" key={read.identifier}>
                <EmailRead readInfo={read} />
              </div>
            ))}
          </Accordion.Body>
        </Accordion>
      )}
    </div>
  );
}
